import * as React from "react";

import {
  Box,
  makeStyles,
  Avatar,
  Paper,
  Badge,
  Button,
} from "@material-ui/core";
import { usePopup } from "react-hook-popup";
// import SettingsIcon from "@material-ui/icons/Settings";
import EditIcon from "../../../assets/icons/edit.png";
import settings from "../../../utils/settings";
import { useRecordContext } from "ra-core";
import SimplePopupDialog from "../../../components/SimplePopupDialog";
const useStyles = makeStyles((theme) => ({
  uploadImage_paper: {
    backgroundColor: "#ffe9d6",
    width: "100%",
    height: "100%",
    paddingTop: 19,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    borderWidth: 0,
  },
  editIcon: {
    height: 27,
    width: 27,
  },
  avatar: {
    width: "200px",
    height: "200px",
    fontSize: 50,
    color: "orange",
    borderWidth: 10,
    backgroundColor: "white",
  },
  avatarBorder: {
    marginTop: 20,
    justifyContent: "center",
    display: "flex",
    width: "200px",
    height: "200px",
    alignItem: "center",
  },
  button: {
    marginTop: 20,
    color: theme.white,
    borderColor: theme.orange,
    width: 200,
    height: 40,
    fontSize: 16,
  },
  changePasswordButton: {
    marginTop: 80,
    color: theme.orange,
    borderColor: theme.orange,
    width: 200,
    height: 40,
    fontSize: 16,
  },
}));
const ImageChanger = ({ resource, noImage, customComponent }) => {
  const classes = useStyles();
  const record = useRecordContext();
  const [image, setImage] = React.useState(record.image_url);
  const [imageData, setImageData] = React.useState();
  const [showPopup] = usePopup("success", ({ message, handleClose }) => (
    <SimplePopupDialog
      message={message?.message}
      title={message?.title}
      handleClose={handleClose}
      onConfirm={message?.onConfirm}
    />
  ));

  const [showAlert] = usePopup("alert", ({ message, handleClose }) => (
    <SimplePopupDialog
      message={message?.message}
      title={message?.title}
      handleClose={handleClose}
      error={true}
    />
  ));
  const { token } = settings();

  const onChangeSelectImageHandler = (file) => {
    //Simple Validate image
    if (file.size > 10000000) {
      showAlert({ title: "Error", message: "File size is too large." });
      return;
    }

    setImageData({
      rawFile: file,
      src: URL.createObjectURL(file),
      title: "item",
    });
    setImage(URL.createObjectURL(file));
  };

  const handleUpdateImage = async () => {
    try {
      const formData = new FormData();
      formData.append("__v", record.__v);
      formData.append("image", imageData.rawFile);
      formData.append("action", "upload_image");

      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/${resource}/${record.id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + token,
          },
          body: formData,
        }
      );
      if (!result.ok) {
        return showAlert({
          title: "Error",
          message: "Can't upload file",
        });
      }
      return showPopup({
        title: "Success",
        message: "Update successfully",
        onConfirm: () => {
          window.location.reload();
        },
      });
    } catch (error) {}
  };
  return (
    <Paper className={classes.uploadImage_paper}>
      {!noImage ? (
        <>
          <Box
            borderColor="orange"
            border={5}
            borderRadius="50%"
            className={classes.avatarBorder}
          >
            <input
              accept="image/*"
              id="contained-button-file"
              type="file"
              style={{ display: "none" }}
              onChange={(e) => onChangeSelectImageHandler(e.target.files[0])}
            />
            <label htmlFor="contained-button-file">
              <Badge
                overlap="circle"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                badgeContent={
                  <Avatar
                    alt="edit"
                    src={EditIcon}
                    className={classes.editIcon}
                  />
                }
              >
                <Avatar src={image} alt="?" className={classes.avatar} />
              </Badge>
            </label>
          </Box>
          <Button
            variant="contained"
            color="primary"
            disabled={!imageData}
            onClick={handleUpdateImage}
            className={classes.button}
          >
            Update image
          </Button>{" "}
        </>
      ) : (
        <></>
      )}
      {customComponent ? customComponent : null}
    </Paper>
  );
};

export default ImageChanger;
